var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40.0001 31.0456 40.0001 19.9999C40.0001 8.95422 31.0457 -8.39233e-05 20 -8.39233e-05C8.95435 -8.39233e-05 4.57764e-05 8.95422 4.57764e-05 19.9999C4.57764e-05 31.0456 8.95435 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9566 19.9999C26.9566 21.739 23.842 26.0868 20.0001 26.0868C16.1581 26.0868 13.0436 21.739 13.0436 19.9999C13.0436 16.1578 16.1581 13.0434 20.0001 13.0434C23.842 13.0434 26.9566 16.1578 26.9566 19.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9566 19.9999C26.9566 23.842 23.842 26.9564 20.0001 26.9564C16.1581 26.9564 13.0436 23.842 13.0436 19.9999",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3731 26.149L29.2174 24.3047L30.447 25.5343L28.6026 27.3786L27.3731 26.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2984 29.2229L26.1427 27.3786L27.3723 28.6082L25.528 30.4525L24.2984 29.2229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0622 29.8375L32.9065 27.9932L34.1361 29.2228L32.2918 31.0671L31.0622 29.8375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9875 32.9119L29.8318 31.0676L31.0614 32.2972L29.2171 34.1415L27.9875 32.9119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2175 27.9933L31.0618 26.149L32.2914 27.3786L30.4471 29.2229L29.2175 27.9933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1436 31.0674L27.988 29.223L29.2175 30.4526L27.3732 32.2969L26.1436 31.0674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0703 13.8543L26.1521 8.93603L27.3817 7.70646L32.2999 12.6247L31.0703 13.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1512 12.6252L24.3069 10.7809L25.5364 9.55135L27.3807 11.3957L26.1512 12.6252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2251 15.6999L27.3808 13.8555L28.6103 12.626L30.4546 14.4704L29.2251 15.6999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8393 8.93581L27.995 7.09148L29.2245 5.8619L31.0689 7.70623L29.8393 8.93581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.915 12.0109L31.0707 10.1665L32.3003 8.93696L34.1446 10.7813L32.915 12.0109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09027 27.9899L12.0085 32.9082L10.7789 34.1377L5.8607 29.2195L7.09027 27.9899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0083 29.2185L13.8527 31.0628L12.6231 32.2923L10.7788 30.448L12.0083 29.2185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93417 26.1452L10.7785 27.9896L9.54893 29.2191L7.7046 27.3748L8.93417 26.1452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7786 24.3003L15.6968 29.2185L14.4673 30.4481L9.54904 25.5298L10.7786 24.3003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0081 7.08771L7.08984 12.0059L5.86027 10.7764L10.7785 5.85813L12.0081 7.08771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8522 8.93188L8.93402 13.8501L7.70444 12.6205L12.6227 7.70231L13.8522 8.93188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6985 10.7772L10.7803 15.6955L9.55077 14.466L14.469 9.54772L15.6985 10.7772Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/south_korea.8d481729faffaf35a5b157d1f9e20c61.svg";
export { ForwardRef as ReactComponent };